import React from "react";
import {
  alpha,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  IconButton,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { useUpdatePromptMutation } from "../../redux/slices/indexApiSlice";
import { useState } from "react";
import { IPrompt } from "../../types/prompt";
import PromptDialog from "../dialogs/PromptDialog";
import { DialogMode } from "../../types/dialogmode";
import { Eye, EyeOff } from "react-feather";
import { useTranslation } from "react-i18next";

type PromptCardProps = {
  image?: string;
  prompt: IPrompt;
  chip: JSX.Element;
  handleCardClick?: (selected: IPrompt) => void;
  selected?: boolean;
};
const PromptCard: React.FC<PromptCardProps> = ({
  image,
  prompt,
  chip,
  selected,
  handleCardClick,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const [updatePrompt, { isLoading: updatePromptLoading }] =
    useUpdatePromptMutation();

  const [isDeleting, setIsDeleting] = useState(false);

  const handleOnClick = () => {
    if (handleCardClick) {
      //   setSelected(!isSelected);

      handleCardClick(prompt);
    }
  };

  const backgroundColor = selected
    ? alpha(theme.palette.primary.main, 0.16)
    : null;

  const hidePrompt = async () => {
    const updatedPrompt = { ...prompt, hidden: true };
    await updatePrompt(updatedPrompt);
  };

  const unhidePrompt = async () => {
    const updatedPrompt = { ...prompt, hidden: false };
    await updatePrompt(updatedPrompt);
  };

  return (
    <Card
      sx={{ width: 420, display: "flex", flexDirection: "column" }}
      aria-selected={selected}
      variant="outlined"
    >
      <CardActionArea
        aria-selected={selected}
        sx={{
          backgroundColor: backgroundColor,
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
        onClick={handleCardClick ? handleOnClick : undefined}
      >
        <CardContent sx={{ flexGrow: 1, width: "100%" }}>
          {prompt?.title && (
            <Typography
              gutterBottom
              variant="h5"
              component="h2"
              noWrap
              textOverflow="ellipsis"
            >
              {t(prompt.title)}
            </Typography>
          )}

          {/* {chip} */}
          <Tooltip title={prompt?.body}>
            <Typography mb={4} color="textSecondary" component="p">
              {prompt?.body}
            </Typography>
          </Tooltip>
        </CardContent>
      </CardActionArea>

      <CardActions>
        <IconButton
          size="small"
          onClick={() => (prompt.hidden ? unhidePrompt() : hidePrompt())}
        >
          {prompt.hidden ? <Eye /> : <EyeOff />}
        </IconButton>

        <PromptDialog
          prompt={prompt}
          mode={DialogMode.Edit}
          iconOnly
          disabled={isDeleting}
        />

        <PromptDialog
          prompt={prompt}
          mode={DialogMode.Delete}
          iconOnly
          disabled={isDeleting}
        />
      </CardActions>
    </Card>
  );
};

export default PromptCard;
